export enum StorageUnits {
  Megabyte = 'MB',
}
